/**
 * Look up a required element by id.
 *
 * Throws rather than returning null: a missing id is a wiring mistake in
 * `index.html`, and failing at boot beats failing on the player's first tap.
 */
export function must<T extends Element = HTMLElement>(id: string): T {
  const node = document.getElementById(id);
  if (!node) throw new Error(`Missing required element #${id}`);
  return node as unknown as T;
}

/** Show or hide an element without disturbing its stylesheet display mode. */
export function setVisible(node: HTMLElement, visible: boolean): void {
  node.style.display = visible ? '' : 'none';
}

/** Restart a CSS animation that's already applied. */
export function replayAnimation(node: HTMLElement, className: string): void {
  node.classList.remove(className);
  void node.offsetWidth; // force reflow so the animation re-runs
  node.classList.add(className);
}
